import React, { useState } from 'react';
import EmpleadoForm from '../components/EmpleadoForm';
import { useAuth } from '../hooks/useAuth';
import { useEmpresaNavigate } from '../hooks/useEmpresaPath';

const NuevoEmpleado = () => {
  const empresaNavigate = useEmpresaNavigate();
  const { selectedCompany, empresaIdFromUrl } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [mensaje, setMensaje] = useState({ tipo: '', texto: '', visible: false });

  const mostrarMensaje = (tipo, texto) => {
    setMensaje({ tipo, texto, visible: true });
    setTimeout(() => setMensaje({ ...mensaje, visible: false }), 5000);
  };

  const handleSubmit = async (empleadoData) => {
    if (!empresaActiva?.id) {
      mostrarMensaje('error', 'No hay empresa seleccionada');
      return;
    }

    try {
      setIsLoading(true);
      
      console.log('Datos del empleado a crear:', {
        ...empleadoData,
        empresa_id: empresaActiva.id
      });

      // Simulación de creación exitosa
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      mostrarMensaje('success', 'Empleado creado exitosamente');
      
      // Redirigir a la lista de empleados después de 2 segundos
      setTimeout(() => {
        empresaNavigate('/empleados');
      }, 2000);

    } catch (error) {
      console.error('Error al crear empleado:', error);
      mostrarMensaje('error', 'Error al crear el empleado');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    empresaNavigate('/empleados');
  };

  const empresaActiva = selectedCompany || (empresaIdFromUrl ? { id: empresaIdFromUrl } : null);

  if (!empresaActiva?.id) {
    return (
      <div className="p-6">
        <div className="flex flex-col items-center justify-center h-64">
          <div className="text-gray-400 mb-4">
            <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">No hay empresa seleccionada</h3>
          <p className="text-gray-500 text-center">
            Selecciona una empresa para agregar empleados.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      {/* Header */}
      <div className="mb-6">
        <div className="flex items-center space-x-4 mb-4">
          <button
            onClick={handleCancel}
            className="flex items-center text-gray-600 hover:text-gray-900"
          >
            <svg className="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Volver
          </button>
        </div>
        <h1 className="text-3xl font-bold text-gray-900">Nuevo Empleado</h1>
        <p className="text-gray-600 mt-2">
          Agregar empleado al sistema - {selectedCompany.name}
        </p>
      </div>

      {/* Mensajes */}
      {mensaje.visible && (
        <div className={`mb-6 p-4 rounded-md ${
          mensaje.tipo === 'success' ? 'bg-green-100 text-green-700 border border-green-300' : 
          'bg-red-100 text-red-700 border border-red-300'
        }`}>
          <div className="flex items-center">
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {mensaje.tipo === 'success' ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              )}
            </svg>
            {mensaje.texto}
          </div>
        </div>
      )}

      {/* Formulario */}
      <div className="bg-gray-50 rounded-lg p-6">
        <EmpleadoForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default NuevoEmpleado; 